import {AxiosServer, ArrRemoveSubItem, AxiosEsb} from '../../utils';
import {server} from '../../config/serverConfig';
import {message,Statistic} from 'antd';
import clientRecommendRd from "../reducers/clientRecommendRd";

let namespace = 'clientLegalPerson_';

//直接dispatch 为同步方法，比如  dispatch({type:'login/set',payload:{loading:false}});
//store 使用了thunk中间件，以下方法均为异步加载。

function format(input) {
	var n = parseFloat(input).toFixed(2);
	var re = /(\d{1,3})(?=(\d{3})+(?:\.))/g;
	return n.replace(re, "$1,");
}


const clientLegalPersonAc ={
	SET:(value) =>(dispatch,getState)=>{
		dispatch({type: namespace+'forcedUpdate', payload: value})},

	GET:(value)=>(dispatch,getState)=>{

		let store =getState().clientLegalPersonRd;
		let {dataFetchProps,pagination} =store;
		let {current:currentPage,pageSize} =pagination;
		dataFetchProps ={...dataFetchProps,...value,currentPage,pageSize}
		let Axios = AxiosServer();

		return Axios.post('/clientLegalPerson/findAll',dataFetchProps).then((res)=>{

			if (res.data.status == true){
				pagination ={...pagination,total:res.data.count}
				dispatch({type: namespace+'forcedUpdate', payload: {data:res.data.data, pagination:pagination,dataLoading: false}});
				return '刷新成功'
			}else{
				dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: false}});
				return '刷新失败'
			}

		}).catch((err)=>{
			message.error('userlist ' + err,10);
			dispatch({type: namespace+'forcedUpdate', payload: {dataLoading: false}});
			return '错误'
	})},



}



export {clientLegalPersonAc};
